// extracted by mini-css-extract-plugin
export default {"root":"user-profile_root__CcxhC","popup":"user-profile_popup__UKXwy","popupContainer":"user-profile_popupContainer__jZdl8"};